import(/* webpackMode: "eager", webpackExports: ["LandingHeader"] */ "/home/runner/work/mdsite4/mdsite4/app/_components/landing-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/runner/work/mdsite4/mdsite4/app/_components/sections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Calculator"] */ "/home/runner/work/mdsite4/mdsite4/components/pricing-calculator/calculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AspectRatio"] */ "/home/runner/work/mdsite4/mdsite4/components/ui/aspect-ratio.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/node_modules/.pnpm/next@15.5.10_@babel+core@7.28.3_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_react-dom@19_rsxbpatvq2qagx3m4vyis2rtqy/node_modules/next/dist/client/app-dir/link.js");
